/**
 * RoleGate
 * Renders children only if the current user has the required role.
 * Redirects to /dashboard otherwise.
 */
import { useUser } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';

interface RoleGateProps {
  role: 'admin' | 'user';
  children: ReactNode;
}

export function RoleGate({ role, children }: RoleGateProps) {
  const { isLoaded, user } = useUser();

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <span className="loading loading-spinner loading-lg" />
      </div>
    );
  }

  const meta = user?.publicMetadata as Record<string, unknown> | null | undefined;
  const userRole = meta?.role === 'admin' ? 'admin' : 'user';

  if (userRole !== role) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
